// HomePage.js
import React from "react";
import SlideSoutien from "../../components/slideSoutien";
import Newsletter from "../../components/newsletter";
const SoutienPage = () => {
  return (
    <div>
      <SlideSoutien />
      <Newsletter />
    </div>
  );
};

export default SoutienPage;
